import {  Directive,  Input, OnInit } from "@angular/core";
import { Store } from "@ngxs/store";
import { StateListenerComponent } from "../../../../shared/components/scan-listener/state-listener.component";
import { Subscription, Observable, of } from "rxjs";
import { Catalog, Client, GetTicketsAction, Ticket, TicketPagedList, AuthenticationService, User } from "wms-lib";
import * as _ from 'lodash';

@Directive({selector: 'appTicketListCards'})
export class TicketListCardsBaseComponent extends StateListenerComponent implements OnInit {
  @Input() public status: Catalog;
  @Input()
  public get filter(): string[] {
    return this._filter;
  }
  public set filter(value: string[]){
    this._filter = value;
    this.page[this.client_id] = null;
    this.loadFirstPageOfClientData(this.status.key);
  }

  ticket_paged_list: TicketPagedList;
  tickets: {[id:number]: Ticket};
  page: {[client:number]: {page: number, all_loaded: boolean}} = {};
  saving$: Observable<{[id:number]: boolean}> = of({});
  protected clear_loaded_pages: boolean;
  private tickets_subscriptions: {[name: string]: Subscription} = {};
  private _current_client: Client;
  private _client_id: number = 0;
  private _filter: string[] = undefined;

  constructor(protected store: Store, protected authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
    this.addSub(this.store.select(state => state.catalogsState.active_client).subscribe(client => {
      this._current_client = client;
      this.closeClientSubscriptionOnChange();
      this.setTicketsSubscription();
      this.loadFirstPageOfClientData(this.status.key);
    }));
    this.saving$ = this.store.select(state => state.helpDeskState.saving);
  }


  get client_id(): number {
    return !this._client_id ? 0 : (this._current_client && this._current_client.id ) || -1
  }

  get canDelete(): boolean {
    return this.current_user.isSupervisor;
  }

  get current_user(): User {
    return this.authenticationService.currentUserValue;
  }

  cardClientName(ticket: Ticket): String {
    return ticket.client ? ticket.client.name : '';
  }

  cardDescription(ticket: Ticket): String {
    return ticket.description;
  }

  cardCreatedBy(ticket: Ticket): string {
    return `Created by: ${ticket.created_by ? ticket.created_by.username: ''}`;
  }

  cardAssignTo(ticket: Ticket): string {
    return `Assign to: ${ticket.assign_to ? ticket.assign_to.username: ''}`;
  }

  cardClosedBy(ticket: Ticket): string {
    return `Closed by: ${ticket.closed_by ? ticket.closed_by.username: ''}`;
  }

  cardFullAuthors(ticket: Ticket): string {
    let msg = this.cardCreatedBy(ticket) + '  ' + this.cardAssignTo(ticket);
    if (ticket.status_key == "C") msg += ' ' + this.cardClosedBy(ticket);
    return msg;
  }

  canDrag(ticket: Ticket): boolean {
    return Ticket.canAssignTicket(this.current_user, ticket);
  }

  canEdit(ticket: Ticket): boolean {
    return Ticket.canEditTicket(this.current_user, ticket);
  }

  protected disablePaging(enabled: boolean) {}

  private closeClientSubscriptionOnChange() {
    _.keys(this.tickets_subscriptions).forEach((name: string) => {
      if (name !== `${this.client_id}${this.status.key}`){
        this.tickets_subscriptions[name].unsubscribe();
        delete this.tickets_subscriptions[name];
      }
    });
  }

  private setTicketsSubscription() {
    this.tickets_subscriptions[`${this.client_id}${this.status.key}`] = this.store.select(state => state.helpDeskState.tickets).subscribe(clients => {
      if(this.client_id){
        this.ticket_paged_list = _.get(clients, `${this.client_id}.${this.status.key}`, {});
        this.tickets = this.ticket_paged_list.items;
      } else {
        let list = _(clients)
          .flatMap((b)=>_.values(b))
          .flatMap((b)=>_.values(b.items))
          .orderBy(['updated_at'],['desc'])
          .groupBy('id')
          .map(_.head)
          .filter((a)=>a.status_key === this.status.key)
          .orderBy(['created_at'], ['desc'])
          .value();
        _.set(clients, `${this.client_id}.${this.status.key}.items`, _.keyBy(list, 'id'));
        this.ticket_paged_list = clients[this.client_id][this.status.key];
        this.tickets = this.ticket_paged_list.items;
      }
      if (this.page[this.client_id]){
        this.page[this.client_id].all_loaded = this.ticket_paged_list.all_loaded
        this.disablePaging(this.ticket_paged_list.all_loaded);
      }
    });
    this.addSub(this.tickets_subscriptions[`${this.client_id}${this.status.key}`]);
  }

  private loadFirstPageOfClientData(status: string) {
    if (this.page[this.client_id] === undefined || this.page[this.client_id] === null) {
      this.page[this.client_id] = {all_loaded : false, page: 0 };
      this.requestTicketsByClient(this.client_id,status);
    }
  }


  protected requestTicketsByClient(client_id: number, status_key: string, page?: number) {
    this.page[client_id].page = page || this.page[client_id].page + 1;
    return this.store.dispatch(new GetTicketsAction({
      status_key,
      client_id,
      page: this.page[client_id].page,
      clear_loaded_pages: this.clear_loaded_pages,
      filter: this.filter
    }));
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
